(() => {
	angular.module('main').controller('BasePathController', BasePathController);

	BasePathController.$inject = ['$scope', 'accountService'];

	function BasePathController($scope, accountService) {
		$scope.$watch('$viewContentLoaded', () => {
			checkHomePathChange();
		});

		$scope.$on('$destroy', () => {
			$scope.navObservable.unsubscribe();
		});

		function checkHomePathChange() {
			$scope.navObservable = accountService.navDataObservable.subscribe(
				data => {
					$scope.home_path = data.home_path;
				}
			);
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/basePathController.js